<template>
  <modal :show="show" @change="$emit('change',$event)" width="550" :headerClass="currentLocale === 'ru' ? 'bg-main-orange white--text helvetica-roman fs-18' : 'bg-main-orange white--text rubik-medium fs-18'">
    <template v-slot:header>
      <span>{{$t('modals.modalIndicationsInfo.title')}}</span>
    </template>
    <template v-slot:main>
      <div class="modal-info text-center mx-7">
        <p class="text-center pt-5 pb-5 pl-4 pr-4 mb-0">
            {{$t('modals.modalIndicationsInfo.infoPart1')}}
        </p>
        <p class="text-center pb-5 pl-4 pr-4 mb-0">
            {{$t('modals.modalIndicationsInfo.infoPart2')}}
        </p>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from "../common/Modal";
import { mapGetters, mapState } from "vuex";

export default {
  name: "ModalIndicationInfo",
  components: { Modal },
  model: {
    prop: "show",
    event: "change"
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    currentMonth: new Date().getMonth()
  }),
  computed: {
    ...mapGetters("locale",["currentLocale"]),
  },
  methods: {},
  created() {},
  watch: {}
};
</script>

<style lang="scss">
</style>
